import axios from 'axios';

const api = axios.create({
    baseURL: "https://reputation-api.ebit.com.br/reputation/"
});

export default api;